




















export default

	data: ->
		loaded: false

